import atendimentoDomiciliar from './atendimentoDomiciliar'
import atendimentoIndividual from './atendimentoIndividual'
import atendimentoOdontologico from './atendimentoOdontologico'
import atividadeColetiva from './atividadeColetiva'
import avaliacao from './avaliacao'
import cadastroDomiciliar from './cadastroDomiciliar'
import cadastroIndividual from './cadastroIndividual'
import exportacao from './exportacao'
import fichaComplementar from '@/router/atencao-basica/fichaComplementar'
import fichaVacinacao from './fichaVavinacao'
import mapaAtendimento from './mapaAtendimento'
import marcadorConsumoAlimentar from '@/router/atencao-basica/marcadorConsumoAlimentar'
import parametrizacao from './parametrizacao'
import procedimento from './procedimento'
import relatorioAcessoCuidadoProgramado from './relatorioAcessoCuidadoProgramado'
import relatorioAtendimentoDomiciliar from './relatorioAtendimentoDomiciliar'
import relatorioAtendimentoOdontologico from './relatorioAtendimentoOdontologico'
import relatorioAvaliacaoElegibilidadeAdmissao from './relatorioAvaliacaoElegibilidadeAdmissao'
import relatorioCadastroConsistente from './relatorioCadastroConsistente'
import relatorioCuidadoDesenvolvimentoInfantil from './relatorioCuidadoDesenvolvimentoInfantil'
import relatorioCuidadoGestacaoPuerperio from './relatorioCuidadoGestacaoPuerperio'
import relatorioCuidadoMulherPrevencaoCancer from './relatorioCuidadoMulherPrevencaoCancer'
import relatorioCuidadoPessoaComDiabete from './relatorioCuidadoPessoaComDiabete'
import relatorioCuidadoPessoaHipertensao from './relatorioCuidadoPessoaHipertensao'
import relatorioCuidadoPessoaIdosa from './relatorioCuidadoPessoaIdosa'
import relatorioEstatisticoAtendimento from './relatorioEstatisticoAtendimento'
import relatorioEstatisticoPacienteCadastrado from './relatorioEstatisticoPacienteCadastrado'
import relatorioInconsistencia from './relatorioInconsistencia'
import relatorioIndicadorSad from './relatorioIndicadorSad'
import relatorioVisitaDomiciliar from './relatorioVisitaDomiciliar'
import reterritorializacao from './reterritorializacao'
import visitaDomiciliar from './visitaDomiciliar'
import relatorioAtividadeColetiva from './relatorioAtividadeColetiva'

export default [
    {
        path: 'atencao-basica',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...atendimentoDomiciliar,
            ...atendimentoIndividual,
            ...atendimentoOdontologico,
            ...atividadeColetiva,
            ...avaliacao,
            ...cadastroDomiciliar,
            ...cadastroIndividual,
            ...exportacao,
            ...fichaComplementar,
            ...fichaVacinacao,
            ...mapaAtendimento,
            ...marcadorConsumoAlimentar,
            ...parametrizacao,
            ...procedimento,
            ...relatorioAcessoCuidadoProgramado,
            ...relatorioAtendimentoDomiciliar,
            ...relatorioAtendimentoOdontologico,
            ...relatorioAvaliacaoElegibilidadeAdmissao,
            ...relatorioCadastroConsistente,
            ...relatorioCuidadoDesenvolvimentoInfantil,
            ...relatorioCuidadoGestacaoPuerperio,
            ...relatorioCuidadoMulherPrevencaoCancer,
            ...relatorioCuidadoPessoaComDiabete,
            ...relatorioCuidadoPessoaHipertensao,
            ...relatorioCuidadoPessoaIdosa,
            ...relatorioEstatisticoAtendimento,
            ...relatorioEstatisticoPacienteCadastrado,
            ...relatorioInconsistencia,
            ...relatorioIndicadorSad,
            ...relatorioVisitaDomiciliar,
            ...reterritorializacao,
            ...visitaDomiciliar,
            ...relatorioAtividadeColetiva
        ]
    }
]
